<template>
  <Portal to="modal" :disabled="inline">
    <transition name="modal">
      <div class="modal-mask" :class="{ inline }" @click.self="onClose" @touchmove="stopScroll" @wheel="stopScroll">
        <div class="modal" :class="{ scrollable, full }">
          <header class="header">
            <h1>{{ title }}</h1>
            <CloseIcon class="close" @click="onClose" />
          </header>
          <div class="modal-main">
            <!-- @slot コンテンツエリア書き換え -->
            <slot name="contents">
              <div class="contents">
                <slot />
              </div>
            </slot>
          </div>
          <footer v-if="$slots.footer" class="footer">
            <slot name="footer" />
          </footer>
          <LoadingIndicator v-if="loading" />
        </div>
      </div>
    </transition>
  </Portal>
</template>

<script>
import { Portal } from 'portal-vue'
import LoadingIndicator from '@/components/molecules/LoadingIndicator'
import CloseIcon from '@/components/icons/close'

/**
 * モーダル
 */
export default {
  name: 'Modal',
  components: {
    Portal,
    LoadingIndicator,
    CloseIcon,
  },
  props: {
    /** タイトル */
    title: { type: String, default: null },
    /** ローディング中 */
    loading: { type: Boolean, default: false },
    /** コンテンツエリアのスクロール可否 */
    scrollable: { type: Boolean, default: false },
    /** 全画面モーダル */
    full: { type: Boolean, default: false },
    /**
     * インライン表示（スタイルガイド用）
     * @ignore
     */
    inline: { type: Boolean, default: false },
  },
  methods: {
    stopScroll(e) {
      if (!e.target.closest('.modal-main')) {
        e.preventDefault()
        e.stopPropagation()
      }
    },
    onClose() {
      /** 閉じる */
      this.$emit('close')
    },
  },
}
</script>

<style lang="postcss" scoped>
.modal-mask {
  align-items: center;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  transition: opacity 0.3s ease;
  width: 100%;
  z-index: 2;

  &.inline {
    height: 480px;
    position: relative;
    width: auto;
  }
}

.modal {
  background: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  max-height: calc(100% - 32px);
  position: relative;
  transition: all 0.3s ease;
  width: calc(100% - 32px);

  &.full {
    height: 100%;
    max-height: 100%;
    width: 100%;
  }

  @media screen and (min-width: 768px) {
    height: 480px;
    max-width: 940px;

    &.full {
      bottom: 0;
      height: auto;
      left: 0;
      margin: 0 auto;
      position: absolute;
      right: 0;
      top: 80px;
      width: calc(100% - 48px);
    }
  }
}

.header {
  align-items: center;
  box-sizing: border-box;
  display: flex;
  flex-shrink: 0;
  height: 48px;
  justify-content: center;
  position: relative;
}

h1 {
  font-size: 16px;
  margin: 0;
  text-align: center;
  white-space: nowrap;
}

.close {
  cursor: pointer;
  fill: var(--text-color);
  padding: 8px;
  position: absolute;
  right: 8px;
  top: 4px;
}

.modal-main {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

.contents {
  display: flex;
  flex-direction: column;
  padding: 0 16px 16px;
}

.footer {
  box-sizing: border-box;
  padding: 8px 16px;

  @media screen and (min-width: 768px) {
    padding: 16px;
  }
}

.scrollable {
  & .header {
    border-bottom: 1px solid var(--border-color);
  }

  & .main {
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }
}

/* 以下 transition 用 */
.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}
</style>
